import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { SHRIMP_STEPS, IMAGES } from "@/data/content";
import { motion } from "framer-motion";

export default function Shrimp() {
  return (
    <section id="shrimp" className="relative py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <Reveal>
            <SectionHeading number="09" eyebrow="Shrimp & Crab Farming" title="RAS-assisted farming, built on discipline."
              subtitle="High-tech Recirculating Aquaculture Systems that keep each stage of the crop under careful control." />
            <p className="mt-6 text-base text-slate-300 leading-relaxed">
              Our planned shrimp and crab farms use Recirculating Aquaculture Systems (RAS) — controlled,
              high-tech production where water is continuously treated and reused. From system preparation
              and quality seed selection through stocking, aeration, water quality management, feeding,
              biosecurity, monitoring and harvesting — every step is designed around a zero-waste approach.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="relative">
              <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-amber-500/10 to-cyan-500/10 blur-2xl" />
              <img src={IMAGES.shrimpDetail} alt="Shrimp farming pond" className="relative h-[420px] w-full object-cover rounded-[1.75rem] border border-white/10" />
            </div>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3">
          {SHRIMP_STEPS.map((s, i) => (
            <motion.div
              key={s}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="rounded-xl border border-white/10 bg-[#071728]/70 px-3 py-4 text-center hover:border-amber-400/40 transition-colors"
            >
              <span className="font-mono-tech text-[0.65rem] text-amber-400/80">{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-1 text-xs font-medium text-slate-200 leading-tight">{s}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
